import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getSymbolsPositions} from 'src/openapi/admin/apis/GetSymbolsPositionsApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectSymbolPositions} from './services/dictionary-slice';

export const useSymbolPositions = () => {
    const apiDispatch = useAppDispatch();
    const symbolPositions = useSelector(selectSymbolPositions);

    const loadSymbolPositions = useCallback(() => {
        if (!symbolPositions.length) {
            apiDispatch(getSymbolsPositions());
        }
    }, [symbolPositions.length, apiDispatch]);

    return {symbolPositions, loadSymbolPositions};
};
